var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOverview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8 2.6C21.8 1.1 20.7 0 19.2 0H2.7C1.1 0 0 1.1 0 2.7C0 8.6 0 14.5 0 20.3C0 20.5 0 20.6 0 20.8C0.3 22.1 1.4 23 2.7 23C5 23 7.2 23 9.5 23H19C19.2 23 19.4 23 19.6 23C20.9 22.8 21.7 21.7 21.7 20.4C21.7 18.3 21.7 16.2 21.7 14V8.9C21.8 6.8 21.8 4.7 21.8 2.6ZM19.7 20.2C19.7 20.7 19.5 20.9 18.9 20.9H2.8C2.2 20.9 2.1 20.7 2.1 20.2V2.8C2.1 2.2 2.3 2 2.9 2H9.9H18.9C19.4 2 19.7 2.2 19.7 2.8V20.2ZM15.8 11.2C15.9 11.7 15.7 12.1 15.3 12.4C15.1 12.5 14.9 12.5 14.7 12.5H7.1C6.5 12.5 6 12.1 6 11.5C6 11.2 6.1 11 6.3 10.8C6.5 10.6 6.8 10.5 7.1 10.5H14.8C15.2 10.5 15.6 10.8 15.8 11.2ZM6 6.6C6 6.3 6.1 6.1 6.3 5.9C6.5 5.7 6.8 5.6 7.1 5.6H14.8C15.3 5.6 15.7 6 15.8 6.4C15.9 6.9 15.6 7.4 15.1 7.6C15 7.6 14.8 7.6 14.7 7.6H8.2H7.1C6.4 7.6 6 7.2 6 6.6ZM15.8 16.4C15.8 16.7 15.7 16.9 15.5 17.1C15.3 17.3 15 17.4 14.7 17.4H13.4H7.1C6.8 17.4 6.5 17.3 6.3 17.1C6.1 16.9 6 16.7 6 16.4C6 15.8 6.5 15.4 7.1 15.4H14.7C15.3 15.4 15.8 15.8 15.8 16.4Z",
    fill: "#00406A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverview);
export default __webpack_public_path__ + "static/media/overview.5bb55c0e461b089e6e991f063a32ef18.svg";
export { ForwardRef as ReactComponent };